<script>
  import 'smelte/src/tailwind.css'
  import Router from 'svelte-spa-router'
  import Nav from './components/Nav.svelte'
  import Home from './routes/Home.svelte'

  import Footer from './components/Footer.svelte'
  import LazyImage from './components/LazyImage.svelte'
  import Machines from './components/InstallBase/Machines.svelte'
  import Projects from './components/InstallBase/Projects.svelte'
  import ConditionMonitoring from './components/ConditionMonitoring/Home.svelte'
  import ParametersView from './components/ConditionMonitoring/ParametersView.svelte'
  import Parameter from './components/ConditionMonitoring/Parameter.svelte'
  import MeasurementProtocol from './components/ConditionMonitoring/Protocol.svelte'
  import SparePartsHome from './components/SpareParts/SparePartsHome.svelte'
  import SparePartsOverview from './components/SpareParts/SparePartsOverview.svelte'
  import Breadcrumb from './components/Breadcrumb.svelte'
  import { fl_01_small_jpg } from './image-base64'
  import Metrics from './components/Metrics.svelte'
  import Settings from './routes/Settings.svelte'
  import SearchView from './components/Freshdesk/SearchView.svelte'
  import { onMount } from 'svelte'
  import { checkLastVisited } from './roles'

  import ArrowUp from './components/ArrowUp.svelte'
  import { widget } from './components/DocumentLibrary/fresh-widget'
  import AlertInfoBanner from './components/AlertInfoBanner.svelte'
  import { userStore } from './store'
  import { location } from 'svelte-spa-router'
  import BlockInfo from './components/BlockInfo.svelte'
  import Tracker from './tracking'
  import {getURL} from "./utils";
  import axios from "axios";
  import AlertBox from "./components/AlertBox.svelte";

  let isLoaded = true
  const routes = {
    '/': Home,
    '/search': SearchView,
    '/settings': Settings,
    '/installed-base': Projects,
    '/installed-base/conveyors': Machines,
    '/installed-base/projects': Projects,
    '/condition-monitoring': ConditionMonitoring,
    '/condition-monitoring/params': ParametersView,
    '/condition-monitoring/param/:id': Parameter,
    '/condition-monitoring/protocol/:id': MeasurementProtocol,
    '/spare-part-list-generator': SparePartsOverview,
    '/spare-part-list-generator/:projectNo': SparePartsHome,
  }

  let tempMessages = []

  onMount(() => {
    const tracker = new Tracker()
    tracker.init()
    checkLastVisited()
    getTempMessages()
  })

  // Switzerland, Brazil, India, China, Russia, Japan, Turkey, Mexico
  const alertCountries = ['SZ', 'BR', 'IN', 'CN', 'RU', 'JP', 'TR', 'MX']

  $: showAlert = $location !== '/'
    && $userStore.userInfo
    && (
      $userStore.userInfo.country && alertCountries.includes($userStore.userInfo.country.toUpperCase())
      || $userStore.roles.includes('alert_banner')
    )
  $: showTempMessage = tempMessages!=null && tempMessages.length>0

  widget()

  async function getTempMessages(){
    const url = getURL('/flws/messages')
    await axios.get(url)
          .then( res => {
            tempMessages = res.data
            const now = new Date().toJSON().slice(0,10)
            tempMessages = tempMessages.filter(m => m.validFrom <= now && m.validTo >= now)
          })
          .catch(err => {
            console.log('[ERROR] getTempMessages ', err)
          })
  }
</script>

<Metrics />

<BlockInfo />

<main class="min-h-screen flex flex-col relative">
  {#if isLoaded}
    <Nav class="flex-shrink" />

    <div class="bg-transparent relative w-full flex-grow mb-12">
      <div class="absolute top-0 left-0">
        <Breadcrumb />
      </div>

      {#if showAlert}
        <div class="mt-12 mx-12 shadow-xl">
          <AlertInfoBanner />
        </div>
      {/if}

      {#if showTempMessage}
        <div class="absolute right-12 w-1/3 my-12 z-50">
          <AlertBox messages={tempMessages} />
        </div>
      {/if}

      <LazyImage full={"static/img/fl_01.jpg"} small={fl_01_small_jpg} height={'450px'} shadow={true} zoom={true}
                 grayscale="0%" brightness="1"/>
      <div class="pt-20">
        <Router {routes} />
      </div>
    </div>


    <Footer class="flex-shrink" />
  {:else}
    <p class="text-primary-300">Loading ...</p>
  {/if}

</main>

<ArrowUp />

<style>
    :global(html) {
        box-sizing: border-box;
        font-size: 81.25%;
        line-height: 1.15;
        font-family: "Roboto", sans-serif;
    }

    :global(body) {
        background-color: rgb(240, 240, 240);
    }
    /*
    :global(.leaflet-top) {
        z-index: 30;
    }
    :global(.leaflet-control) {
        z-index: 20;
    }
    */
    main {
        text-align: center;
        /*padding: 1em;*/
        /*min-width: 1240px;*/
        margin: 0 auto;
    }

    :global(.user-avatar) {
        font-size: 1.6rem;
        color: #888888;
        margin-right: 0.5rem;
    }

    @media (min-width: 640px) {
        main {
            /*max-width: none;*/
        }
    }
</style>
